import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginacaoClient } from '../page/client/paginacaoClient';
import { Client, ClientDocumento } from '../page/client/client';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  apiURL: string = environment.apiBaseUrl + 'client';

  constructor(private http: HttpClient) { }

  save(client: Client): Observable<Client> {
    return this.http.post<Client>(this.apiURL, client);
  }

  list(page: number, size: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  update(client: Client): Observable<any> {
    return this.http.put<Client>(`${this.apiURL}/${client.id}`, client);
  }

  findClientById(id: number): Observable<Client> {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

  findClientByIdActive(id: number): Observable<Client> {
    return this.http.get<any>(`${this.apiURL}/active/${id}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  findClient(page: number, size: number , parametroConsulta: string, tipoFiltro: string): Observable<PaginacaoClient> {
    const params = new HttpParams().set('page', page).set('size', size).set('tipoFiltro', tipoFiltro).set('parametroConsulta', parametroConsulta);
    return this.http.get<any>(`${this.apiURL}/consulta?${params}`);
  }

  consultar(filtros: {
    id?: number | null;
    razaoSocial?: string | null;
    documento?: string | null;
    plano?: string | null;
    segmento?: string | null;
    estado?: string | null;
    colaboradorId?: number | null;
    clientePagadorId?: number | null;
  }, page: number, size: number): Observable<PaginacaoClient> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    if (filtros.id != null) {
      params = params.set('id', filtros.id.toString());
    }
    if (filtros.razaoSocial?.trim()) {
      params = params.set('razaoSocial', filtros.razaoSocial.trim());
    }
    if (filtros.documento?.trim()) {
      params = params.set('documento', filtros.documento.trim());
    }
    if (filtros.plano) {
      params = params.set('plano', filtros.plano);
    }
    if (filtros.segmento) {
      params = params.set('segmento', filtros.segmento);
    }
    if (filtros.estado) {
      params = params.set('estado', filtros.estado);
    }
    if (filtros.colaboradorId != null) {
      params = params.set('colaboradorId', filtros.colaboradorId.toString());
    }
    if (filtros.clientePagadorId != null) {
      params = params.set('clientePagadorId', filtros.clientePagadorId.toString());
    }
    return this.http.get<any>(`${this.apiURL}/consulta`, { params });
  }
 
    listarCliente(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/listarCliente`);
  }

  criarCadastroWowve(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiURL}/criarCadastroWowve/${id}`, null);
  }

  alterarPlanoWowve(id: number): Observable<any> {
    return this.http.post<any>(`${this.apiURL}/alterarPlanoWowve/${id}`, null);
  }
  
  alterarStatusWowve(id: number, novoStatus: boolean): Observable<any> {
    return this.http.post<any>(`${this.apiURL}/alterarStatusWowve/${id}`, novoStatus);
  }

  listarDocumentos(clientId: number): Observable<ClientDocumento[]> {
    return this.http.get<ClientDocumento[]>(`${this.apiURL}/${clientId}/documentos`);
  }

  anexarDocumento(clientId: number, arquivo: File): Observable<ClientDocumento> {
    const form = new FormData();
    form.append('arquivo', arquivo);
    return this.http.post<ClientDocumento>(`${this.apiURL}/${clientId}/documentos`, form);
  }

  baixarDocumento(clientId: number, documentoId: number): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${clientId}/documentos/${documentoId}`, { responseType: 'blob' });
  }

  removerDocumento(clientId: number, documentoId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${clientId}/documentos/${documentoId}`);
  }

}